// src/components/Header.js
import React from "react";
import { NavLink } from "react-router-dom";
import { useLanguage } from "../contexts/LanguageContext";
import { Globe } from "lucide-react";
import { translations, uiFlags } from "../data/mock";

const Header = () => {
  const { language, toggleLanguage, t } = useLanguage();

  const linkClass = ({ isActive }) =>
    `nav-link${isActive ? " nav-link--active" : ""}`;

  return (
    <header className="header" role="banner">
      <div className="container">
        <div className="header-content">
          <NavLink to={`/${language}`} className="logo" aria-label="Eva Tazzari — Home">
            EVA TAZZARI
          </NavLink>

          <nav aria-label="Main">
            <ul className="nav-menu">
              <li className="nav-item">
                <NavLink to={`/${language}`} end className={linkClass}>
                  {t(translations.nav.home)}
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink to={`/${language}/bio`} className={linkClass}>
                  {t(translations.nav.bio)}
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink to={`/${language}/works`} className={linkClass}>
                  {t(translations.nav.works)}
                </NavLink>
              </li>

              {/* NUOVA SEZIONE F.A.K.E. */}
              <li className="nav-item nav-item-fake">
                <NavLink to={`/${language}/fake`} className={linkClass}>
                  <span className="fake-link">
                  <span className="fake-text">F.A.K.E.</span>
                  {!!uiFlags?.showFakeNewBadge && (
                  <span className="nav-badge-new">NEW</span>
                    )}
                </span>
               </NavLink>
              </li>

              <li className="nav-item">
                <NavLink to={`/${language}/tinder`} className={linkClass}>
                  {t(translations.nav.tinder)}
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink to={`/${language}/articles`} className={linkClass}>
                  {t(translations.nav.articles)}
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink to={`/${language}/contact`} className={linkClass}>
                  {t(translations.nav.contact)}
                </NavLink>
              </li>
            </ul>
          </nav>

          <button
            type="button"
            className="language-switcher"
            onClick={toggleLanguage}
            aria-label="Cambia lingua"
            title="Cambia lingua"
          >
            <Globe size={16} />
            {/* mostra SEMPRE la lingua di destinazione */}
            <span>{language === "it" ? "EN" : "IT"}</span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
